const Footer = () => {
  const quickLinks = [
    { name: 'Giới thiệu', href: '#about' },
    { name: 'Khóa học', href: '#programs' },
    { name: 'Đào tạo Doanh nghiệp', href: '#corporate' },
    { name: 'Liên hệ', href: '#contact' },
  ];

  const programs = [
    'Master The Life Game',
    'Ultimate Sales Skill A-Z',
    'Leadership For Result',
    'Become The Sales Master',
    'Coach The Coach',
    'Elite Camp',
  ];

  const socialLinks = [
    {
      name: 'Facebook',
      icon: '📘',
      href: 'https://www.facebook.com/upower.vn'
    },
    {
      name: 'YouTube',
      icon: '�',
      href: 'https://www.youtube.com/channel/UC-VeHEp0k0FXhHO0jMrLWug'
    },
  ];

  const scrollToSection = href => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-primary mb-2">
                UPOWER GROUP
              </h3>
              <p className="text-gray-400 font-medium">ONE TEAM - ONE GOAL</p>
            </div>

            <p className="text-gray-300 leading-relaxed mb-6">
              Tổ chức hàng đầu Việt Nam trong lĩnh vực đào tạo Tư duy, Phát
              triển bản thân, Bán hàng, Marketing, Lãnh đạo & Coaching.
            </p>

            <div className="bg-primary rounded-lg p-4 mb-6">
              <p className="text-white font-bold text-sm">
                &ldquo;Vì Một Cộng Đồng Sống Có Mục Đích&rdquo;
              </p>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary transition-colors duration-300"
                  title={social.name}
                >
                  <span className="text-lg">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Liên kết nhanh</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={e => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-gray-300 hover:text-primary transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-lg font-bold mb-6">Chương trình nổi bật</h4>
            <ul className="space-y-3">
              {programs.map((program, index) => (
                <li key={index}>
                  <a
                    href="#programs"
                    onClick={e => {
                      e.preventDefault();
                      scrollToSection('#programs');
                    }}
                    className="text-gray-300 hover:text-primary transition-colors duration-200 text-sm"
                  >
                    {program}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Thông tin liên hệ</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <span className="text-primary mr-3 mt-1">📞</span>
                <div>
                  <p className="text-gray-300 text-sm">Hotline</p>
                  <a
                    href="tel:0934926613"
                    className="text-white font-medium hover:text-primary transition-colors duration-200"
                  >
                    093 49 26 613
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <span className="text-primary mr-3 mt-1">✉️</span>
                <div>
                  <p className="text-gray-300 text-sm">Email</p>
                  <a
                    href="mailto:admin@upower.vn"
                    className="text-white font-medium hover:text-primary transition-colors duration-200"
                  >
                    admin@upower.vn
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <span className="text-primary mr-3 mt-1">🌐</span>
                <div>
                  <p className="text-gray-300 text-sm">Website</p>
                  <a
                    href="https://upower.vn"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium hover:text-primary transition-colors duration-200"
                  >
                    upower.vn
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <span className="text-primary mr-3 mt-1">📍</span>
                <div>
                  <p className="text-gray-300 text-sm">Địa chỉ</p>
                  <p className="text-white font-medium">
                    Tầng 2 - Số 9A Phạm Cự Lượng, Phường Tân Sơn Hòa, TP.HCM
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>Bản quyền © 2025 Upower Group. Mọi quyền được bảo lưu.</p>
            </div>

            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <a
                href="#"
                className="text-gray-400 hover:text-primary text-sm transition-colors duration-200"
              >
                Chính sách Bảo mật
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary text-sm transition-colors duration-200"
              >
                Điều khoản Sử dụng
              </a>
              <button
                onClick={scrollToTop}
                className="bg-primary hover:bg-primary-700 text-white p-2 rounded-lg transition-colors duration-300"
                title="Về đầu trang"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Signup */}
      <div className="bg-primary">
        <div className="container-custom py-8">
          <div className="text-center">
            <h4 className="text-xl font-bold text-white mb-4">
              Đăng ký nhận thông tin mới nhất
            </h4>
            <p className="text-primary-100 mb-6">
              Cập nhật các khóa học, sự kiện và chia sẻ hữu ích từ UPOWER
            </p>
            <div className="max-w-md mx-auto flex">
              <input
                type="email"
                placeholder="Nhập email của bạn"
                className="flex-1 px-4 py-3 rounded-l-lg border-0 focus:ring-2 focus:ring-white focus:outline-none text-gray-900 placeholder-gray-500"
              />
              <button className="bg-white text-primary font-semibold px-6 py-3 rounded-r-lg hover:bg-gray-100 transition-colors duration-300">
                Đăng ký
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
